export default "__VITE_ASSET__CpMr7FYf__"